
(function () {
  const SELECTOR = '.header_cart_info.show_cart_subtotal';

  function setVisible(isVisible) {
    document.querySelectorAll(SELECTOR).forEach(el => {
      el.style.display = isVisible ? '' : 'none';
    });
  }

  async function refreshFromCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      setVisible((cart.item_count || 0) > 0);
    } catch (e) {
      // If cart can't be read, don't hide (safer fallback)
      setVisible(true);
    }
  }

  // Initial
  refreshFromCart();

  // Update after cart changes (covers most themes)
  document.addEventListener('cart:refresh', refreshFromCart);
  document.addEventListener('cart:updated', refreshFromCart);

  // Also re-check after clicks on add-to-cart buttons
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && form.matches('form[action^="/cart/add"]')) {
      setTimeout(refreshFromCart, 600);
    }
  }, true);

  // Shopify section reload
  document.addEventListener('shopify:section:load', refreshFromCart);
})();

